import { render, staticRenderFns } from "./SystemDialog.vue?vue&type=template&id=41a64d07"
import script from "./SystemDialog.vue?vue&type=script&lang=js"
export * from "./SystemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a64d07')) {
      api.createRecord('41a64d07', component.options)
    } else {
      api.reload('41a64d07', component.options)
    }
    module.hot.accept("./SystemDialog.vue?vue&type=template&id=41a64d07", function () {
      api.rerender('41a64d07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SystemDialog.vue"
export default component.exports